import type { LimitOrder } from 'state/secondaryMarket/limit-order/limitOrder.model';
import { initialLimitOrder } from 'state/secondaryMarket/limit-order/limitOrder.model';
import type { RealtimeMap } from 'state/secondaryMarket/realtime/realtime.model';
import { initialRealtimeMap } from 'state/secondaryMarket/realtime/realtime.model';

import type { CpOrder } from './cpOrder/cpOrder.model';
import { initialCpOrder } from './cpOrder/cpOrder.model';
import type { DlpOrder } from './dlpOrder/dlpOrder.model';
import { initialDlpOrder } from './dlpOrder/dlpOrder.model';
import type { Live } from './live/live.model';
import { initialLive } from './live/live.model';
import type { ProductSearchState } from './productSearch';
import { initialProductSearchState } from './productSearch';
import type { RealtimeQuote } from './realtimeQuote/realtimeQuote.model';
import { initialRealtimeQuote } from './realtimeQuote/realtimeQuote.model';
import type { SharedReferential } from './referential/referential.model';
import { initialSharedRerential } from './referential/referential.model';

/**
 * Trade ways
 *
 * Order is important!
 */
export const allTradeWays = ['ClientSell', 'ClientBuy'] as const;
export type TradeWay = (typeof allTradeWays)[number];
export type TradeAuthorization = 'Ask only' | 'Bid only' | 'Full';

export type SecondaryOrderStatePath = 'live' | 'limitOrder' | 'cpOrder';
export type SecondaryMarketState = Readonly<{
  productSearch: ProductSearchState;
  realtimeQuote: RealtimeQuote;
  cpOrder: CpOrder;
  live: Live;
  referential: SharedReferential;
  limitOrder: LimitOrder;
  realtime: RealtimeMap;
  dlpOrder: DlpOrder;
}>;

export const initialSecondaryMarketState: SecondaryMarketState = {
  productSearch: initialProductSearchState,
  realtimeQuote: initialRealtimeQuote,
  cpOrder: initialCpOrder,
  live: initialLive,
  referential: initialSharedRerential,
  limitOrder: initialLimitOrder,
  realtime: initialRealtimeMap,
  dlpOrder: initialDlpOrder,
};
